export default __webpack_public_path__ + "static/media/rtt-logo.eaf058ed.png";